module.exports = __webpack_public_path__ + "static/img/bg.60baae6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg.png
// module id = C34Q
// module chunks = 8